import { matchPath } from 'react-router-dom';

import { ROUTES } from '@routes/routes.constants';
import { QUERY_STRINGS, RoutePath } from '@routes/routes.types';

/** Check if the current URL pathname should be ignored from redirect URL search param */
export const isIgnoredRedirectSeachParamRoute = () =>
  [ROUTES.LOGOUT, ROUTES.LOGIN].some((route) =>
    matchPath(window.location.pathname, route)
  );

/** Add redirect URL search param (targeting the current path) to the given path */
export const getPathWithRedirectParam = (path: RoutePath) => {
  if (isIgnoredRedirectSeachParamRoute() || path === window.location.pathname) {
    return path;
  }

  const urlParams = new URLSearchParams();

  urlParams.set(
    QUERY_STRINGS.REDIRECT,
    window.location.pathname + window.location.search
  );

  return `${path}?${urlParams.toString()}`;
};

/** Utility function for replacing the current URL with a given (complete) URL.
 * Suitable for navigating to external URLs programmatically */
export const navigateToHref = (url: string) => (window.location.href = url);

const getURLSearchParams = () => new URLSearchParams(window.location.search);

export const urlSearchParams = {
  get: (param: QUERY_STRINGS) => getURLSearchParams().get(param),
  has: (param: QUERY_STRINGS) => getURLSearchParams().has(param),
  getFTNCallbackToken: () => getURLSearchParams().get(QUERY_STRINGS.TOKEN),
  getRedirect: () => getURLSearchParams().get(QUERY_STRINGS.REDIRECT),
};
